module.exports = __webpack_public_path__ + "img/vehicle-options-black-nissan.ce6ab15f.png";